module.exports = __webpack_public_path__ + "static/img/original_ac8ac102-b3f8-431a-8519-3dd4765321b0_IMG_20241022_004152~2.c725df77.jpg";